import { ADMIN_BONDS_ACTIONS } from "../../../actionType/admin/bond";
import {BOND_PRICES_ACTIONS } from "../../../actionType/admin/BondPrices";

const intialState = {
  bondsCreatData: {},
  isBondsCreatLoader: false,
  bondsCreatPriceData: {},
  isBondsCreatPriceLoader: false,
  bondsList: [],
  isBondsListLoader: false,
  bondsDeleteLoader: false,
  bondsDeleteData: {},
};

export const adminBondReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMIN_BONDS_ACTIONS.BONDS_REQUEST:
      return { ...state, isBondsCreatLoader: true };
    case ADMIN_BONDS_ACTIONS.BONDS_RESPONSE:
      return {
        ...state,
        bondsCreatData: payload,
        isBondsCreatLoader: false,
      };
    case ADMIN_BONDS_ACTIONS.BONDS_ERROR:
      return {
        ...state,
        bondsCreatData: payload,
        isBondsCreatLoader: false,
      };

    //BONDS_PRICES_ACTIONS
    case BOND_PRICES_ACTIONS.GET_BOND_PRICES_REQUEST:
      return { ...state, isBondsCreatPriceLoader: true };
    case BOND_PRICES_ACTIONS.GET_BOND_PRICES:
      return {
        ...state,
        bondsCreatPriceData: payload,
        isBondsCreatPriceLoader: false,
      };
    case BOND_PRICES_ACTIONS.GET_BOND_PRICES_ERROR:
      return {
        ...state,
        bondsCreatPriceData: payload,
        isBondsCreatPriceLoader: false,
      };

    // BONDS_LIST_ACTIONS
    case ADMIN_BONDS_ACTIONS.BONDS_LIST_REQUEST:
      return { ...state, isBondsListLoader: true };
    case ADMIN_BONDS_ACTIONS.BONDS_RESPONSE:
      return {
        ...state,
        bondsList: payload,
        isBondsListLoader: false,
      };
    case ADMIN_BONDS_ACTIONS.BONDS_LIST_RESPONSE:
      return {
        ...state,
        bondsList: payload,
        isBondsListLoader: false,
      };

    // BONDS_EDIT_ACTIONS

    case ADMIN_BONDS_ACTIONS.BONDS_EDIT_REQUEST:
      return { ...state, isBondsCreatLoader: true };
    case ADMIN_BONDS_ACTIONS.BONDS_EDIT_RESPONSE:
      return {
        ...state,
        bondsCreatData: payload,
        isBondsCreatLoader: false,
      };
    case ADMIN_BONDS_ACTIONS.BONDS_EDIT_ERROR:
      return {
        ...state,
        bondsCreatData: payload,
        isBondsCreatLoader: false,
      };
    // BONDS_DELETE_ACTIONS

    case ADMIN_BONDS_ACTIONS.BONDS_DELETE_REQUEST:
      return { ...state, bondsDeleteLoader: true };
    case ADMIN_BONDS_ACTIONS.BONDS_DELETE_REQUEST:
      return {
        ...state,
        bondsDeleteData: payload,
        bondsDeleteLoader: false,
      };
    case ADMIN_BONDS_ACTIONS.BONDS_DELETE_ERROR:
      return {
        ...state,
        bondsDeleteData: payload,
        bondsDeleteLoader: false,
      };
    default:
      return state;
  }
};
